import { useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { Logo } from './Logo'

const links = [
  { to: '/', label: 'Strona główna', end: true },
  { to: '/oprawa-wokalna', label: 'Oprawa ślubu' },
  { to: '/lekcje-spiewu', label: 'Lekcje śpiewu' },
]

export function Header() {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()
  const contactButton = pathname === '/lekcje-spiewu'
    ? { to: '/lekcje-spiewu#kontakt', label: 'Zapisz się na lekcję' }
    : { to: '/oprawa-wokalna#kontakt', label: 'Zapytaj o termin' }

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <Logo />
        <button
          className="menu-toggle"
          type="button"
          aria-label={open ? 'Zamknij menu' : 'Otwórz menu'}
          aria-expanded={open}
          aria-controls="main-navigation"
          onClick={() => setOpen((value) => !value)}
        >
          <span /><span /><span />
        </button>
        <nav id="main-navigation" className={`main-nav${open ? ' main-nav--open' : ''}`} aria-label="Główna nawigacja">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? 'is-active' : undefined)}
            >
              {link.label}
            </NavLink>
          ))}
          <Link className="button button--small" to={contactButton.to} onClick={() => setOpen(false)}>{contactButton.label}</Link>
        </nav>
      </div>
    </header>
  )
}
